<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>企业信息</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="descriptions_content" v-loading="contentLoading">
      <div class="editBtn" @click="editCompanyBtn">编辑</div>
      <el-form>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="企业名称：">
              {{ companyInfo.etpName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="社会信用代码：">
              {{ companyInfo.etpUscc }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="企业性质：">
              {{ companyInfo.etpPropertyName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="所属行业：">
              {{ companyInfo.etpIndustryName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="注册资本：">
              {{ companyInfo.etpRegCapital }} 万
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="证件签发日期：">
              {{ $parseTime(companyInfo.etpCertBeginDate, '{y}-{m}-{d}') }} 至 {{ $parseTime(companyInfo.etpCertEndDate,
                '{y}-{m}-{d}') }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="注册地址：">
              {{ companyInfo.etpFullAddr }}
            </el-form-item>
          </el-col>
          <el-col :span="24" style="margin-top: -20px;">
            <div style="display: flex; align-items: center;">
              <span style="padding-top: 25px;">营业执照：</span>
              <upLoadImg v-model="companyInfo.etpIdcard" :limit="upload.limit" :viewImage="upload.viewImage">
              </upLoadImg>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog title="编辑企业信息" :visible.sync="dialogVisible" width="750px" :close-on-click-modal="false">
      <edit-company></edit-company>
    </el-dialog>
  </div>
</template>
<script>
import { updateC, detailC } from '@/api/user/company'
import upLoadImg from '@/components/uploadImg/index.vue'
import EditCompany from '@/components/editCompany.vue'
export default {
  components: {
    EditCompany, upLoadImg
  },
  data() {
    return {
      companyInfo: {},
      contentLoading: false,
      dialogVisible: false,
      enterpriseFrom: {
        data: '',
        value1: ''
      },
      upload: {
        limit: 1,
        viewImage: true
      }
    }
  },
  mounted() {
    this.getComanyInfo()
  },
  methods: {
    getComanyInfo() {
      this.contentLoading = true
      const data = {}
      detailC(data).then((res) => {
        if (res.success) {
          this.companyInfo = res.result
        } else {
          this.$message.error(res.message)
        }
        this.contentLoading = false
      })
    },
    editCompanyBtn() {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.descriptions_content {
  background: #fff;
  padding: 20px;
  position: relative;

  .editBtn {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 14px;
    color: #3d8bfc;
    cursor: pointer;
    z-index: 99;
  }
}

::v-deep .el-dialog__body {
  padding: 10px 20px 30px 20px;
}

::v-deep .djsc_btn {
  display: none;
}

::v-deep .el-dialog__wrapper {
  .djsc_btn {
    display: block;
  }
}

::v-deep .el-upload-list__item-name {
  font-weight: bold;
}

::v-deep .el-form-item__content {
  font-weight: bold;
}
</style>
